import Event from '../../core/Event';

export interface ProductSearchableAttributes {
    brands: string[];
    seasons: string[];
    collaborations: string[];
    categories: string[];
    types: string[];
}

export default class ProductsAttributesReceived extends Event {
    public static type = 'ProductsAttributesReceived';

    constructor(public readonly searchableAttributes: ProductSearchableAttributes[]) {
        super(ProductsAttributesReceived.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/ProductsAttributesReceived.ts